import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { PropType as PolygotPropType } from 'redux-polyglot';
import moment from 'moment';
import { autobind } from 'core-decorators';
import { Skeleton, Alert } from 'antd';
import { Line } from 'components/Charts';
import Query from 'components/Providers/QueryProvider';

import FormatTime from '../../formatTime';

class PreCheckWaitTime extends PureComponent {
  @autobind
  renderData(canvas) {
    const { dimension, result, p } = this.props;
    const ctx = canvas.getContext('2d');
    const gradient = ctx.createLinearGradient(0, 0, 0, 315);
    gradient.addColorStop(0, 'rgb(60, 179, 113, .4)');
    gradient.addColorStop(0.6, 'rgb(60,179,113, 0)');

    const xfmt = ['minute', 'hour'].includes(dimension) ? (x => moment(x[0]).toDate()) : (x => moment(x[0].slice(0, 19)).toDate());
    const data = result.content.rows
      .sort((a, b) => a[0].localeCompare(b[0]));
    const labels = data.map(xfmt);
    const datasets = [{
      label: p.tt('wait_time'),
      data: data.map(x => x[1]),
      backgroundColor: gradient,
      borderColor: '#3CB371',
      pointBackgroundColor: '#3CB371',
      borderWidth: 2,
      pointRadius: data.length > 30 ? 0 : undefined,
    }];
    return {
      labels,
      datasets,
    };
  }

  render() {
    const {
      fetching,
      failed,
      error,
      result,
      p,
      dimension,
    } = this.props;
    if (fetching && (!result || !result.content || !result.content.rows.length)) {
      return <Skeleton active />;
    }
    if (failed || error) {
      return <Alert message={p.t('errors.loading', { error })} type="error" />;
    }

    return (
      <div style={{ height: '315px' }}>
        <Line
          title={p.tt('wait_time')}
          data={this.renderData}
          yFmtr={FormatTime}
          yLabel={p.tt('minutes')}
          xTimeUnit={['minute', 'hour'].includes(dimension) ? undefined : 'day'}
        />
      </div>
    );
  }
}

PreCheckWaitTime.propTypes = {
  fetching: PropTypes.bool,
  failed: PropTypes.bool,
  error: PropTypes.any,
  result: PropTypes.any,
  p: PolygotPropType,
  dimension: PropTypes.string,
};

export default Query(({
  zoneId,
  startDate,
  endDate,
  dimension,
  lane,
  name,
}) => ({
  name,
  zoneId,
  startTime: startDate,
  endTime: endDate,
  metrics: 'waitTime',
  dimensions: dimension,
  filters: lane,
}))(PreCheckWaitTime);
